import { render, staticRenderFns } from "./SpacingVertical.vue?vue&type=template&id=0199a072&scoped=true"
import script from "./SpacingVertical.vue?vue&type=script&lang=js"
export * from "./SpacingVertical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0199a072",
  null
  
)

export default component.exports